import React, {useEffect, useState} from "react";
import ProgrammeCardImage from "../../assets/img/programme-card-1.png";
import ProgrammeCardImage2 from "../../assets/img/programme-card-2.png";
import ProgrammeCardImage3 from "../../assets/img/programme-card-3.png";
import ProgrammeArrowImage from '../../assets/img/programme-arrow.png'
import {Link, useHistory} from "react-router-dom";
import {FrontendRoutes} from "../../constants";
import {VideoTypes} from '../ballroom/BallroomPage';

const menus = [
    '',
    '',
    ''
]
const ProgramPage = () => {
    const [width, setWidth] = useState(window.innerWidth * 0.15);
    const history = useHistory();
    
    useEffect(() => {
        function handleResize() {
            if (window.innerWidth > 900) {
                setWidth(window.innerWidth * 0.15)
            } else {
                setWidth(window.innerWidth * 0.2)
            }
        }

        window.addEventListener('resize', handleResize)
    })

    const handleProgrammerClick = (type) => {
        window.location.href = '/ballroom?type=' + type;
    }

    return (
        <div className="programme-container" style={{marginBottom: width * 0.4, marginTop: '3.1vw'}}>
            <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
                <div className="card-container">
                    <Link to={FrontendRoutes.BALLROOM(VideoTypes.WELCOME)}>
                        <img alt='' src={ProgrammeCardImage} style={{width: '15vw', height: '25vw'}}/>
                    </Link>
                </div>
                <div className="gold-shadow"/>
            </div>


            <div>
                <img alt={''} src={ProgrammeArrowImage} style={{width: '2.1vw'}}/>
                <div style={{ height: '30px'}}/>
            </div>

            <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
                <div className="card-container">
                    <Link to={FrontendRoutes.BALLROOM(VideoTypes.PANEL)}>
                        <img alt='' src={ProgrammeCardImage2} style={{width: '15vw', height: '25vw'}}/>
                    </Link>
                </div>
                <div className="gold-shadow"/>
            </div>
            <div>

                <img alt={''} src={ProgrammeArrowImage} style={{width: '2.1vw'}}/>
                <div style={{ height: '30px'}}/>
            </div>
            <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
                <div className="card-container">
                    <Link to={FrontendRoutes.BALLROOM(VideoTypes.AWARD)}>
                        <img alt='' src={ProgrammeCardImage3} style={{width: '15vw', height: '25vw'}}/>
                    </Link>
                </div>
                <div className="gold-shadow"/>
            </div>
        </div>
    );
}
export default ProgramPage;
